export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const USER_INFO_MODAL_VISIBLE = "USER_INFO_MODAL_VISIBLE";
